import Vue from 'vue'
// import * as BMap from 'vue-baidu-map';
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import router from './router'
import VueQuillEditor from 'vue-quill-editor'
import scroll from 'vue-seamless-scroll'
// 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'

import AppPagination from "@/components/Pagination"

Vue.component('AppPagination', AppPagination)
Vue.use(scroll)
 
Vue.use(VueQuillEditor)
 
Vue.use(ElementUI);

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')
